import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import moment from 'moment-timezone'
import {useCallback, useEffect, useState, useMemo} from 'react'
import {getTimezoneLabel} from '../Utils/timezoneHelper'

export function useTimezone() {
  const userValues = useSelector(getAllUserDetails)
  const [userTimezone, setUserTimeZone] = useState<string | null>(null)
  const effectiveTimezone = userTimezone || moment.tz.guess()

  const [diffHours, setDiffHour] = useState(0)

  const toLocalTimezone = useCallback(
    (date: Date): Date => {
      if (!date) return date
      
      const tz = userTimezone || moment.tz.guess()
      // Extract date/time components from the Date object
      const year = date.getFullYear()
      const month = date.getMonth()
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      
      // Create moment in user's timezone with the selected values, then convert to UTC
      const utcDate = moment.tz([year, month, day, hours, minutes, seconds], tz).utc().toDate()
      return utcDate
    },
    [userTimezone]
  )

  const getUserTimezoneNow = useCallback(() => {
    const tz = effectiveTimezone
    return moment.tz(tz).toDate()
  }, [effectiveTimezone])

  useEffect(() => {
    if (userValues && userValues.timeZone) {
      setUserTimeZone(userValues.timeZone)
      // diffHours is no longer used - timezone conversion is handled directly by moment-timezone
      setDiffHour(0)
    }
  }, [userValues?.timeZone])


  const timezoneLabel = useMemo(() => getTimezoneLabel(effectiveTimezone), [effectiveTimezone])

  return {
    userTimezone: effectiveTimezone,
    diffHours,
    getUserTimezoneNow,
    toLocalTimezone,
    getTimezoneLabel,
    timezoneLabel,
  }
}
